'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_SIZES = exports.TEXT_COLORS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = P;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

var _Text = require('../../internal/Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'placeholder': 'ccl-cd31f1773aa0584c'
};
var TEXT_COLORS = exports.TEXT_COLORS = ['black', 'grey', 'light-grey', 'teal', 'green', 'red', 'orange', 'berry', 'white', 'inherit'];

var TEXT_SIZES = exports.TEXT_SIZES = ['regular', 'small', 'x-small'];

/**
 * Generic block paragraph component.
 */
function P(originalProps) {
  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, P.placeholderProps) : originalProps;
  var isBold = props.isBold,
      color = props.color,
      size = props.size,
      spacing = props.spacing,
      adjacentHorizontalSpacing = props.adjacentHorizontalSpacing,
      adjacentVerticalSpacing = props.adjacentVerticalSpacing,
      children = props.children;


  return _react2.default.createElement(
    _Text2.default,
    {
      isBold: isBold,
      color: color,
      size: size,
      element: 'p',
      spacing: spacing,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing,
      isPlaceholder: isPlaceholder,
      placeholderClassName: (0, _classnames3.default)(_defineProperty({}, styles.placeholder, isPlaceholder)),
      isBlock: true
    },
    children
  );
}

P.displayName = 'P';
P.propTypes = _extends({
  /**
   * The child text.
   */
  children: (0, _reactProptypeConditionalRequire2.default)(_propTypes2.default.node, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * The named colour of the text.
   */
  color: _propTypes2.default.oneOf(TEXT_COLORS),

  /**
   * The named size of the text.
   */
  size: _propTypes2.default.oneOf(TEXT_SIZES),

  /**
   * Whether the text is bold.
   */
  isBold: _propTypes2.default.bool

}, _SpacerElement2.default.propTypes);

P.defaultProps = _extends({
  children: null,
  color: 'black',
  size: 'regular',
  isBold: false
}, _SpacerElement2.default.defaultProps);

P.placeholderProps = {
  children: 'placeholder text'
};